import { AppSettings } from 'loopback-react-request';

interface AppConfig extends AppSettings {
  cdn?: string;
  enableLogger: boolean;
  isDevelopment: boolean;
}

export const createApiUrl = (config: AppSettings['config']): string => {
  const port = config.port ? `:${config.port}` : '';
  const path = config.path ? config.path : '';
  return `${config.protokol}://${config.url}${port}${path}`;
};

type EnvType = 'development' | 'production' | 'test' | 'staging' | 'internal';

export const environment = process && process.env && process.env.NODE_ENV as EnvType;

const isDevelopment = (environment && environment === 'development');
const showLog = process && process.env && process.env.REACT_APP_LOG && process.env.REACT_APP_LOG === 'log';

let url = process && process.env && process.env.REACT_APP_API || 'localhost';

export const appSettings: AppConfig = {
  cookieName: 'fs-franke-access-token',
  config: {
    port: isDevelopment && 1337 || undefined,
    protokol: isDevelopment ? 'http' : 'https',
    url,
    path: '/api'
  },
  enableLogger: showLog ? true : false,
  isDevelopment: isDevelopment ? true : false,
};